import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';

const NetworkErrorBlock = (props) => {
      
    useEffect (() => {
        props.showAppLoader();

        return () => props.hideAppLoader()
    }, []);    
    return (
        <div></div>
    )
}

const mapDispatchToProps = {
    showAppLoader,
    hideAppLoader
}

export default connect(null, mapDispatchToProps)(NetworkErrorBlock)
